// ref: https://confluence.zhihuiya.com/pages/viewpage.action?pageId=124543238

import type { EActivityTriggerType } from '../types/activity-type'

export enum E_ActivityType {
    /**
     * 邀请注册
     */
    inviteRegister = 'inviteRegisterV2',
    /**
     * 反馈
     */
    inviteFeedback = 'inviteFeedback',
    /**
     * 完善信息
     */
    perfectInformation = 'perfectInformation'
}

export enum E_ActivityStatus {
    unfinished = 'UNFINISHED',
    unreceived = 'UNRECEIVED',
    received = 'RECEIVED'
}

export interface IActivityItem {
    enable: boolean
    activity_type: E_ActivityType | string
}

export interface IActivityReceiveItem {
    receive_type: E_ActivityType
    receive_status: E_ActivityStatus
}

export type IGetActivityInitData = IActivityItem[]

export interface IInviteRegisterItem {
    /**
     * 活动类型
     */
    activity_type: string
    /**
     * 活动邀请人数上限
     */
    invite_limit: number
    /**
     * 已成功邀请人数
     */
    invite_num: number
    /**
     * 邀请链接，链接中包含如下字段
     * channel_source=personInviteRegister
     * activity_type=inviteRegister
     * inviter_id={userId}
     * invitation_code=XXX
     */
    invite_link: string
    /**
     * 账号到期日 yyyy-MM-dd
     */
    time_end: string
}

export interface IUserInformation {
    need_company?: boolean,
    company: string,
    need_mobile?: boolean,
    mobile?: string,
    code?: string,
    trigger_manually?: boolean
}

export interface IClueForm {
    company_name: string
    post: string
    name: string
    mobile: string
    code: string
    reason: string[]
    otherReason: string
}

export interface IClueInfo extends IClueForm {
    type: EurekaPackageType
    source_type?: EActivityTriggerType
}

export const ClueReasonOther = 'other';

export interface IAmountItem {
    key: string
    isDivider?: boolean
    support?: boolean
    max_amount?: number
    current_amount?: number
    capacity_dimension?: string
    group_end_at?: string
    end_at?: string
    type?: string
    dimension?: string
    has_share_capacity?: boolean
    children?: IAmountItem[]
}

export type IGetInviteRegisterInfoData = IInviteRegisterItem

/**
 * 自动赋权接口
 */
export interface IAddTrialExtendBody {
    /**
     * 账号注册来源
     */
    channel_source: string
    /**
     * 活动类型
     */
    activity_type: string
    /**
     * 邀请人id
     */
    inviter_id: string
    /**
     * 企业邀请code 企业邀请注册时有值
     */
    invitation_code: string
    /**
     * 邀请人邀请码
     */
    media_type: 'Mobile' | ''
    /**
     * 邀请注册来源
     */
    from?: string
}

export interface IPostSubmitFeedbackParams {
    content: string
}

/**
 * 发送验证码
 */
export enum E_MobileVerifyCodePurpose {
    LOGIN = 'LOGIN',
    LOGIN_REGISTER = 'LOGIN_REGISTER',
    MOBILE_NUMBER_BINDING = 'MOBILE_NUMBER_BINDING',
    UNIONID_BINDING = 'UNIONID_BINDING',
    PASSWORD_FORGOT = 'PASSWORD_FORGOT',
    REGISTER = 'REGISTER',
    SSO_USER_PROFILE = 'SSO_USER_PROFILE',
    SMS_EUREKA = 'SMS_EUREKA',
    SMS_MOBILE_NUMBER_UPDATE = 'SMS_MOBILE_NUMBER_UPDATE',
    SMS_SALES_LEAD = 'SMS_SALES_LEAD'
}

/**
 * 新套餐版本
 */
export enum EurekaPackageType {
    PROTECT_FREE = 'protect_free',
    PROTECT_TRIAL = 'protect_trial',
    PROTECT_COMMERCIAL_OLD = 'protect_commercial_old',
    PROTECT_COMMERCIAL = 'protect_commercial',

    IP_COMMERCIAL = 'ip_commercial',

    MATERIAL_TRIAL = 'material_trial',
    MATERIAL_COMMERCIAL_OLD = 'material_commercial_old',
    MATERIAL_COMMERCIAL = 'material_commercial',
    MATERIAL_COMMERCIAL_RAPID_SEARCH = 'material_commercial_rapid_search',

    AIR_FREE = 'air_free',
    AIR_TRIAL = 'air_trial',
    AIR_COMMERCIAL = 'air_commercial',
    AIR_COMMERCIAL_PROFESSIONAL_EDITION = 'air_commercial_professional_edition',
    AIR_COMMERCIAL_NAVIGATOR_EDITION = 'air_commercial_navigator_edition',

    INSIGHTS_TRIAL = 'insights_trial',
    INSIGHTS_COMMERCIAL = 'insights_commercial',
    LS_COMMERCIAL = 'ls_commercial',
    LS_COMMERCIAL_SHARE = 'ls_commercial_share',
    LS_COMMERCIAL_AGENT = 'ls_commercial_agent',
    LS_COMMERCIAL_PDA_USAGE_PACKAGE = 'ls_commercial_pda_usage_package',

    RD_PERSONAL_COMMERCIAL = 'rd_personal_commercial'
}

/**
 * 套餐基础信息
 */
export interface IPackageType {
    end_at: EurekaPackageType
    eureka_package: string
    trial_package_left_days?: number
    product_type: string
    package_type: 'FREE' | 'TRIAL' | 'COMMERCIAL'
}

export interface ISaveUserInfo {
    company: string
    mobile?: string
    country_code?: string
    trigger_manually: boolean
    role: string
    from: 'eureka_home' | 'patent_view'
}

export interface AccountInfoCn {
    company_name: string
    mobile_number: string
    full_name: string
    job_role: string
}

export interface AccountInfoUs {
    company_name: string
    mobile_number: string
    first_name: string
    last_name: string
    email: string
    industry: string
    country_code: string
}

export interface AccountInfo extends AccountInfoCn, AccountInfoUs {
}

export interface AccountInfoSave extends AccountInfo {
    manual_company: string
    code: string
}

/**
 * 套餐版本
 */
export enum EUserPackage {
    GENERAL_FREEMIUM = 'GENERAL_FREEMIUM', // 范域个人版
    GENERAL_TRIAL = 'GENERAL_TRIAL', // 范域试用版
    GENERAL_ENTERPRISE = 'GENERAL_ENTERPRISE', // 范域企业版
    GENERAL_UNIVERSITY = 'GENERAL_UNIVERSITY', // 范域高校版
    MATERIAL_TRIAL = 'MATERIAL_TRIAL', // 材料试用版
    MATERIAL_ENTERPRISE = 'MATERIAL_ENTERPRISE', // 材料企业版
    AIR_FREEMIUM = 'AIR_FREEMIUM', // Air 基础版
    AIR_TRIAL = 'AIR_TRIAL', // Air 试用版
    AIR_ENTERPRISE = 'AIR_ENTERPRISE', // Air 企业版
    // ... 其他套餐
    NEV_TRIAL = 'NEV_TRIAL'
}

export interface AddTrialInput {
    fromSite?: string
    extendBody?: IAddTrialExtendBody
}

export interface LsPlgUsage {
    user_id: string
    role_expire_at: string
    role_package: 'enterprise' | 'team' | 'personal_pro' | 'free_trial' | 'personal_basic'
    usage: {
        key: 'project_storage' | 'privilege_credit' | 'reword_credit'
        type: string
        capacity_dimension: 'day' | 'month' | 'all'
        support: boolean
        max_amount: number
        current_amount: number
    }[]
}

/**
 * 容量时间线请求参数
 */
export interface ICapacityTimelineRequest {
    /** 容量资源ID，标识具体的容量资源类型 */
    capacity_resource_id: string
    /** 租户用户ID，用于身份识别 */
    tenant_user_id: string
    /** 会话ID，用于会话管理 */
    session_id: string
}

/**
 * 周期容量值对象
 */
export interface ICycleCapacityValue {
    /** 年度容量值 */
    YEARLY?: number
    /** 月度容量值 */
    MONTHLY?: number
    /** 每日容量值 */
    DAILY?: number
}

/**
 * 容量时间线记录
 */
export interface ICapacityTimeLine {
    /** 时间线记录唯一标识 */
    id: string
    /** 套餐包ID */
    package_id: string
    /** 周期容量值对象 */
    cycle_capacity_value: ICycleCapacityValue
    /** 开始时间 (ISO 8601 格式) */
    begin_at?: string
    /** 结束时间 (ISO 8601 格式) */
    end_at: string
}

/**
 * 容量时间线响应
 */
export interface ICapacityTimelineResponse {
    /** 容量资源ID */
    capacity_resource_id: string
    /** 租户用户ID */
    tenant_user_id: string
    /** 容量时间线数组 */
    capacity_time_lines: ICapacityTimeLine[]
}
